export const CUTLIO_BREAKPOINTS = ['xxxl', 'xxl', 'xl', 'lg', 'md', 'sm', 'xs']